<template>
    <div class="creditor-info tab-container">
      <div class="section" >
          <!-- <div class="title">
              <h3>工商信息</h3>
          </div> -->
          <industrialCommercialInfo :dataDetail="detail" v-if="detail"/>
          <div class="intro-y box overflow-hidden mt-5" style="padding: 24px" v-else>暂未收录该企业的相关信息，请核实企业名称</div>
      </div>
      <div v-if="detail">
        <div class="section">
          <div class="intro-y flex items-center mt-5 title">
            <h3 class="text-lg font-medium mr-auto">股东情况</h3>
          </div>
          <div class="intro-y box overflow-hidden mt-5" v-if="stockholder">
            <el-row :gutter="16">
              <el-col :span="10">
                <shareholdingRatioEchart :data='stockholder'/>
              </el-col>
              <el-col :span="14">
                <subscribedCapitalEchart :data='stockholder'/>
              </el-col>
            </el-row>
          </div>
          <div class="intro-y box overflow-hidden mt-5" style="padding: 24px" v-else>系统暂未收录该债务人信息，请核实企业名称是否正确或为个人</div>
        </div>
        <div class="section">
          <div class="intro-y flex items-center mt-5 title">
            <h3 class="text-lg font-medium mr-auto">变更记录</h3>
          </div>
          <div class="intro-y overflow-hidden">
            <div class="intro-y col-span-12 overflow-auto">
              <table class="table table-report -mt-2">
                <thead>
                <tr>
                  <th class="whitespace-no-wrap">序号</th>
                  <th class="whitespace-no-wrap">变更日期</th>
                  <th class="whitespace-no-wrap">变更项目</th>
                  <th class="whitespace-no-wrap">变更前</th>
                  <th class="whitespace-no-wrap">变更后</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in enterpriseDetail"
                    :key="index"
                    class="intro-x"
                >
                  <td>
                    {{index + 1}}
                  </td>
                  <td>
                    <div class="font-medium whitespace-no-wrap">{{
                        item.changeDate
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium whitespace-no-wrap">{{
                        item.projectName
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.beforeContent
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.afterContent
                      }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- <div>
              <a-table style="backgrund-color:#fff;" :columns="columns1" :data-source="enterpriseDetail" :row-key="record => record.id" :pagination="false">
              </a-table>
            </div> -->
            <div class='intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5'>
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :current-page="pageIndex"
                @current-change="currentChange"
                :total="total"
              />
            </div>
          </div>
        </div>
        <div class="section">
          <div class="intro-y flex items-center mt-5 title">
            <h3 class="text-lg font-medium mr-auto">诉讼情况 </h3>
          </div>
          <div class="intro-y overflow-hidden">
            <div class="intro-y col-span-12 overflow-auto">
              <table class="table table-report -mt-2">
                <thead>
                <tr>
                  <th class="whitespace-no-wrap">序号</th>
                  <th class="text-center whitespace-no-wrap">案件名称</th>
                  <th class="text-center whitespace-no-wrap">案由</th>
                  <th class="whitespace-no-wrap">案件金额</th>
                  <th class="text-center whitespace-no-wrap">发布日期</th>
                  <th class="text-center whitespace-no-wrap">案号</th>
                  <th class="text-center whitespace-no-wrap">案件身份</th>
                  <th class="text-center whitespace-no-wrap">执行法院</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in documentInfo"
                    :key="index"
                    class="intro-x"
                >
                  <td>
                    {{index + 1}}
                  </td>
                  <td>
                    <div class="font-medium" style="color: #0A56C5">{{
                        item.caseName
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.brief
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium" style="color: #E82F39">{{
                        item.casePrice
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium  whitespace-no-wrap">{{
                        item.releaseDate
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.caseCode
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.caseIdentity
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.executiveCourt
                      }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class='intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5'>
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize2"
                :current-page="pageIndex2"
                @current-change="currentChange2"
                :total="total2"
              />
            </div>
          </div>
        </div>
        <div class="section">
          <div class="intro-y flex items-center mt-5 title">
            <h3 class="text-lg font-medium mr-auto">立案信息 </h3>
          </div>
          <div class="intro-y overflow-hidden">
            <div class="intro-y col-span-12 overflow-auto">
              <table class="table table-report -mt-2">
                <thead>
                <tr>
                  <th class="whitespace-no-wrap">序号</th>
                  <th class="whitespace-no-wrap">发布日期</th>
                  <th class="whitespace-no-wrap">立案日期</th>
                  <th class="whitespace-no-wrap">案号</th>
                  <th class="whitespace-no-wrap">执行法院</th>
                  <th class="whitespace-no-wrap">履行情况</th>
                  <th class="whitespace-no-wrap">执行依据文号</th>
                  <th class="whitespace-no-wrap">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in loseCreditInfo"
                    :key="index"
                    class="intro-x"
                >
                  <td>
                    {{index + 1}}
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.releaseDate
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.accreditationDate
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.caseCode
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium whitespace-no-wrap">{{
                        item.executiveCourt
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium whitespace-no-wrap">{{
                        item.fulfilSituation
                      }}</div>
                  </td>
                  <td>
                    <div class="font-medium">{{
                        item.executiveNumber
                      }}</div>
                  </td>
                  <td class="table-report__action whitespace-no-wrap">
                    <a class="flex items-center mr-3" href="javascript:;" @click='look(item)'>
                      <SearchIcon class="w-4 h-4 mr-1"/>
                      查看
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class='intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5'>
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize3"
                :current-page="pageIndex3"
                @current-change="currentChange3"
                :total="total3"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="prop-frame" v-if="prop">
        <div class="prop-main">
          <div style="position: absolute;top: 10px;right: 10px;font-size: 24px;cursor: pointer" @click="closeProp()">x</div>
          <div class="prop-m">
            <div class="prop-title">失信被执行人详情</div>
            <div class="break-main">
              <div class="break-line">
                <div class="break-item2">被执行人的履行情况:</div>
                <div class="break-item">{{breakDetail.fulfilSituation}}</div>
                <div class="break-item2">省份:</div>
                <div class="break-item" style="border-right: none;">{{breakDetail.fulfilSituation}}</div>
              </div>
              <div class="break-line">
                <div class="break-item2">案号:</div>
                <div class="break-item">{{breakDetail.caseCode}}</div>
                <div class="break-item2">执行法院:</div>
                <div class="break-item" style="border-right: none;">{{breakDetail.executiveCourt}}</div>
              </div>
              <div class="break-line">
                <div class="break-item2">执行依据文案:</div>
                <div class="break-item">{{breakDetail.executiveNumber}}</div>
                <div class="break-item2">做出执行依据单位:</div>
                <div class="break-item" style="border-right: none;">{{breakDetail.executeUnite}}</div>
              </div>
              <div class="break-line">
                <div class="break-item2">立案日期:</div>
                <div class="break-item">{{breakDetail.accreditationDate}}</div>
                <div class="break-item2">发布日期:</div>
                <div class="break-item" style="border-right: none;">{{breakDetail.releaseDate}}</div>
              </div>
              <div class="break-line">
                <div class="break-item2">失信被执行人行为具体情况:</div>
                <div class="break-item" style="flex: 1;border-right: none;">{{breakDetail.actionRemark}}</div>
              </div>
              <div class="break-line">
                <div class="break-item2">生效法律文书确定的义务:</div>
                <div class="break-item" style="flex: 1;border-right: none;">{{breakDetail.yiWu}}</div>
              </div>
            </div>
            <div v-if="breakList.length > 0">
              <div class="text-lg font-medium mr-auto relevance-title" >关联信息</div>
              <div class="intro-y overflow-hidden mt-5" style="position: relative;">
                <div class="intro-y col-span-12 overflow-auto">
                  <table class="table table-report -mt-2">
                    <thead>
                    <tr>
                      <th class="whitespace-no-wrap">序号</th>
                      <th class="whitespace-no-wrap">裁判文书标题</th>
                      <th class="whitespace-no-wrap">裁决/裁定日期</th>
                      <th class="whitespace-no-wrap">案件身份</th>
                      <th class="whitespace-no-wrap">执行法院</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(item, index) in breakList"
                        :key="index"
                        class="intro-x"
                    >
                      <td>
                        {{index + 1}}
                      </td>
                      <td>
                        <div class="font-medium">{{
                            item.caseName
                          }}</div>
                      </td>
                      <td>
                        <div class="font-medium">{{
                            item.releaseDate
                          }}</div>
                      </td>
                      <td>
                        <div class="font-medium">{{
                            item.caseIdentity
                          }}</div>
                      </td>
                      <td>
                        <div class="font-medium whitespace-no-wrap">{{
                            item.executiveCourt
                          }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import {getBusinessInfo,getStockInfo,getEnterpriseChangeInfo,getDocumentInfo,getLoseCreditInfo,getCaseList} from '../../../api/tenant'
  import shareholdingRatioEchart from './echarts/shareholdingRatioEchart.vue'
  import subscribedCapitalEchart from './echarts/subscribedCapitalEchart.vue'
  import industrialCommercialInfo from './industrialCommercialInfo.vue'
  export default {
    name:'creditorInfo',
    components: {
        shareholdingRatioEchart,
        subscribedCapitalEchart,
        industrialCommercialInfo,
    },
    data(){
      return{
        dataDetail:'',
        detail:{},
        assureList:[],
        pageIndex: 1,
        pageSize: 10,
        pageIndex2: 1,
        pageSize2: 10,
        pageIndex3: 1,
        pageSize3: 10,
        pageIndex4: 1,
        pageSize4: 100,
        stockholder: [],
        enterpriseDetail: [],
        total: 0,
        total2: 0,
        total3: 0,
        documentInfo: [],
        loseCreditInfo: [],
        prop: false,
        breakDetail: '',
        breakList: [],
      }
    },
  methods: {
    look(item){
      this.prop = true;
      this.breakDetail = item;
      let para = {
        keyWord: item.caseCode,
        page: this.pageIndex4,
        perPage: this.pageSize4,
      };
      getCaseList(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.breakList = data.content.list
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
    closeProp(){
      this.prop = false
    },
    currentChange(val){
      this.pageIndex = val
      let para = {
        page: this.pageIndex,
        perPage: this.pageSize,
        keyWord: this.dataDetail
      }
      getEnterpriseChangeInfo(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.enterpriseDetail = data.content.list
          this.total = data.content.total
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
    currentChange2(val){
      this.pageIndex2 = val;
      this.getDocumentInfo();
    },
    currentChange3(val){
      this.pageIndex3 = val;
      this.getLoseCreditInfo();
    },
    getMort(){
      let para = {
        keyWord: this.dataDetail
      }
      getBusinessInfo(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.detail = data.content
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
      //债务人股东信息
      getStockInfo(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.stockholder = data.content.list
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
      //债务人企业变更
      let para2 = {
        page: this.pageIndex,
        perPage: this.pageSize,
        keyWord: this.dataDetail
      }
      getEnterpriseChangeInfo(para2).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.enterpriseDetail = data.content.list
          this.total = data.content.total
        }else {

        }
      }).catch(err => {
        console.log(err);
      })


    },
    getDocumentInfo(){
      let para = {
        keyWord: this.dataDetail,
        page: this.pageIndex2,
        perPage: this.pageSize2,
      }
      getDocumentInfo(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.documentInfo = data.content.list
          this.total2 = data.content.total
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
    getLoseCreditInfo(){
      let para = {
        keyWord: this.dataDetail,
        page: this.pageIndex3,
        perPage: this.pageSize3,
      }
      getLoseCreditInfo(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.loseCreditInfo = data.content.list
          this.total3 = data.content.total
        }else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
  },
  created() {
    this.dataDetail = this.$route.query.broadside
    if(this.dataDetail){
      this.getMort();
      this.getDocumentInfo();
      this.getLoseCreditInfo();
    }
  },
  watch: {
    dataDetail: function () {
      if(this.dataDetail){
        this.getMort();
        this.getDocumentInfo();
        this.getLoseCreditInfo();
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .prop-frame{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    left: 0;
    top: 0;
    z-index: 999;
    .prop-m{
      width: 900px;
      background-color: #fff;
      font-size: 16px;
      padding: 14px;
      overflow: scroll;
      height: 100%;
    }
    .prop-main{
      position: absolute;
      width: 900px;
      left: 50%;
      top: 50%;
      margin-left: -450px;
      margin-top: -18%;
      background-color: #fff;
      height: 70%;
      .prop-title{
        padding-bottom: 12px;
      }
      .break-main{
        border-bottom: 1px solid #666;
        .break-line{
          display: flex;
          border: 1px solid #666;
          box-sizing: border-box;
          border-bottom: none;
          .break-item2{
            padding: 8px;
            width: 210px;
            border-right: 1px solid #666;
          }
          .break-item{
            padding: 8px;
            flex: 1;
            border-right: 1px solid #666;
          }
        }
      }

    }
  }
.blue{
    color:#0A56C5;
}
.red{
    color:#E82F39;
}
h3{
  font-weight: bold;
}
.creditor-info{
    .section{
        .title{
            display: flex;
            justify-content: space-between;
            border-bottom: 1px dashed #E6E6E6;
          padding-bottom: 17px;
            align-items: center;
            h3{
                font-size: 16px;
                color:#333;
                font-weight: 600;
              span{
                color: #0A56C5;
              }
            }
        }
    }
}
</style>
